import { Outlet } from 'react-router-dom';

export const BlankPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
